import Axios from 'axios'

import { NodeData } from 'types/transformation/types/nodes'
import { SimTable } from 'types/transformation/types/tables'

import { getWithRedirect } from 'utils/axios'
import { parseAuthenticationHeader } from 'helpers/Functions'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v4/data-products/tables`

export async function getOne(id: string) {
  return getWithRedirect<SimTable>(`${URL}/${id}`)
}

export async function getVersions(id: string) {
  return getWithRedirect<
    {
      timestamp: string
      modified: string | null
      name: string | null
      copied_from: 'test' | 'production' | null
    }[]
  >(`${URL}/${id}/versions`)
}

export async function getVersion(id: string, timestamp: string) {
  return getWithRedirect<SimTable>(`${URL}/${id}/versions/${timestamp}`)
}

export async function put(id: string, nodes: NodeData[]) {
  return Axios.put<{ data: SimTable }>(
    `${URL}/${id}`,
    { data: nodes },
    parseAuthenticationHeader()
  )
}

/**
 * Promote this table's modelling from the test environment to production.
 * Only meaningful while the test environment is active — the backend rejects
 * the call for a table that already belongs to production.
 */
export async function transferToProduction(id: string) {
  return Axios.post<{
    data: { id: string; technical_name: string; transferred: boolean }
  }>(`${URL}/${id}/transfer`, {}, parseAuthenticationHeader())
}
